const componentCoordinates = {
    desktop : {
        coordinates : {
            text : {
                returnEveryDay : {
                    x : 1420,
                    y : 450,
                },
                forNewRewards : {
                    x : 1400,
                    y : 600,
                },
                nextRewardIn : {
                    x : 1200,
                    y : 1900,
                },
                nextRewardCounter : {
                    x : 1900,
                    y : 1900,
                },
                fiveDayStreak : {
                    x : 150,
                    y : 1200,
                },
                surpriseBag : {
                    x : 2420,
                    y : 1200,
                },
                dailyRewardDayLabel : {
                    x : 400,
                    y : 1550,
                },
                bonezFiveDayTextOffset : {
                    x : 900,
                    y : 320,
                }
            },
            other : {
                dailyBonusSprite : {
                    x : 1850,
                    y : 1300,
                },
                openBagButton : {
                    x : 1850,
                    y : 1950,
                },
                day1BonusSprite : {
                    x : 400,
                    y : 1150,
                },
                fiveDayPlusSign : { //Center of this layout
                    x : 1750,
                    y : 1080,
                },
                particlesXP : {
                    x : 1800,
                    y : 1200,
                },
                checkMark : {
                    x : 180,
                    y : -20,
                }
            }
        },
        scale : {
            bonusSpriteOffset : 670,
            DailyBonusBg : 2.5,
            dailyBonusSprite : 1.5,
            particlesXPLifeSpan : 8400,
            returnEveryDay : 1.2,
            day1BonusSprite : 1.8,
            bonusSprite : 1.4,
            openBagButton : 1,
            dailyRewardDayLabel : 1.2,
            fiveDayStreak : 1,
            checkMark : 0.3,
            fiveDayBonezSpriteOffset : 700,
        },
    },
    mobile : {
        coordinates : {
            text : {
                returnEveryDay : {
                    x : 740,
                    y : 250,
                },
                forNewRewards : {
                    x : 730,
                    y : 360,
                },
                nextRewardIn : {
                    x : 440,
                    y : 1030,
                },
                nextRewardCounter : {
                    x : 1100,
                    y : 1030,
                },
                fiveDayStreak : {
                    x : 150,
                    y : 660,
                },
                surpriseBag : {
                    x : 1420,
                    y : 660,
                },
                dailyRewardDayLabel : {
                    x : 180,
                    y : 880,
                },
                bonezFiveDayTextOffset : {
                    x : 420,
                    y : 160,
                }
            },
            other : {
                dailyBonusSprite : {
                    x : 990,
                    y : 660,
                },
                openBagButton : {
                    x : 990,
                    y : 1030,
                },
                day1BonusSprite : {
                    x : 160,
                    y : 640,
                },
                fiveDayPlusSign : { //Center of this layout
                    x : 810,
                    y : 450,
                },
                particlesXP : {
                    x : 950,
                    y : 700,
                },
                checkMark : {
                    x : 100,
                    y : -20,
                },
                fiveDayBonezSprite : {
                    x : 750,
                    y : 660,
                },
            }
        },
        scale : {
            bonusSpriteOffset : 356,
            returnEveryDay : 0.72,
            day1BonusSprite : 1.2,
            bonusSprite : 0.7,
            openBagButton : 0.6,
            dailyRewardDayLabel : 0.6,
            DailyBonusBg : 1.35,
            fiveDayStreak : 0.45,
            particlesXPLifeSpan : 4400,
            checkMark : 0.15,
            fiveDayBonezSpriteOffset : 300,
        },
    }
}

export default componentCoordinates;